import React from "react";

import cx from "classnames";

import * as styles from "./ComplexBetPill.module.scss";

interface ComplexBetPillProps {
  isWon?: boolean;
  icon: React.ReactNode;
  odds: React.ReactNode;
  className?: string;
}

const ComplexBetPill = ({
  isWon = false,
  icon,
  odds,
  className,
}: ComplexBetPillProps) => {
  return (
    <div
      className={cx(styles.pillContainer, className, {
        [styles.isWon]: isWon,
      })}
    >
      <div className={styles.logoContainer}>
        <div className={styles.logoIcon}>{icon}</div>
        <div className={styles.combosAndOdds}>{odds}</div>
      </div>
    </div>
  );
};

export { ComplexBetPill };
